/**
 * The state/year combinations built into this release, as plain data.
 *
 * Kept apart from versionRouter.ts so the main bundle can read the list without loading the
 * calcs chunk. versionRouter's CALC_VERSIONS registry is typed `Record<CalcVersionKey, ...>`, so
 * a key added here without its calcs (or the reverse) does not compile.
 * See docs/ADDING_A_CALC_VERSION.md.
 */
export interface CalcVersion {
    stateCode: string;
    year: number;
}

/** `${year}-${stateCode}` for every built combination. */
export const CALC_VERSION_KEYS = ['2026-IA', '2025-IA'] as const;

export type CalcVersionKey = typeof CALC_VERSION_KEYS[number];

/** Built state/year combinations, newest year first. */
export function listCalcVersions(): CalcVersion[] {
    return CALC_VERSION_KEYS
        .map(key => {
            const [year, stateCode] = key.split('-');
            return { stateCode, year: Number(year) };
        })
        .sort((a, b) => b.year - a.year || a.stateCode.localeCompare(b.stateCode));
}
